<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Items.StockReasons.List')"
            :contenttext="$t('Items.StockReasons.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Stock Reasons" econtent="Stock Reasons"
              eimg="/src/assets/Img/icons/stockreasons.svg" @createNew="IsAdd" />
            <div class="table-width-80">
              <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" dataKey="Id" :rowHover="true" filterDisplay="menu" :loading="loading1"
                responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single" @row-click="" :exceldownload="true">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton :btnname="$t('btn.plusaddnew')" class="float-rights my-3" @click="IsAdd()" />
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Stock Reason Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:status="{ data }">

                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />
                </template>
                <template v-slot:action="{ data }">
                  <span>
                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="List.length === 0 && !loading" eheader="Stock Reasons" econtent="Stock Reasons"
              eimg="/src/assets/Img/icons/stockreasons.svg" @createNew="IsAdd" />
            <MobileViewCardHeader v-if="List.length !== 0 && !loading">
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in List">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.Code }}</p>
                      <p class="name">{{ item.ReasonName }}</p>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>

                        <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                        <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <p class="light-name">{{ item.Remarks }}</p>
                </div>
              </template>
            </MobileViewCardHeader>
          </div>
        </div>
        <Stockpopup v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
          @loadershow="loading = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>

      <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
      <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
      <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
      <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
        :content="$t('confirmation.editcontent')" />
      <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
        @no="Deletemodel = false" />
      <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
    </b-container>
  </div>
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted, onUnmounted } from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";



import Stockpopup from "../../Items/StockReason/StockReasonCreation.vue";
import StockReasonService from "../../../../Service/StockReasonService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";
import { useI18n } from 'vue-i18n';

export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Stockpopup,


    Tableview,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    EditConfirmation,
    MasterEmpty,
    Loader,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },

  setup() {

    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const toast = useToast();
    const stockreason = ref();
    const showmodalref = ref(false);
    let loading1 = ref(false);
    const showDialog = ref(false);
    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const rowFocus = ref(false);
    let deletepop = ref(false);
    let List: any = ref([]);
    let loading = ref(false);
    let ExportOption = ref("");
    let ExportList = ref([]);
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    const contentdel = ref("");
    let InActivevisible = ref(false);
    let Activevisible = ref(false);
    const datas = ref();
    const menu = ref();
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ReasonName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Remarks: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },

      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [
      {
        header: t('Items.StockReasons.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Items.StockReasons.Code'),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Items.StockReasons.Name'),
        field: "ReasonName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('Items.StockReasons.Remarks'),
        field: "Remarks",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "largewidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Items.StockReasons.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        slot: "status",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));


    const IsAdd = () => {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    };
    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.IsActive == 1) {
        InActivevisible.value = true;
        Activevisible.value = false;
      } else {
        InActivevisible.value = false;
        Activevisible.value = true;
      }

      datas.value = data;
      menu.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: InActivevisible,
            command: async () => {
              IsConfirmEdit(datas.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(datas.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(datas.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(datas.value, 2);
            },
          },
        ],
      },
    ]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await StockReasonService.getlistdata();
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;

            return item;
          });


        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }



    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    //TableView
    async function IsShow() {
      try {
        loading.value = true;
        const response = await StockReasonService.getlistdata();
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            count = count + 1;
            item.RowNumber = count;

            return item;
          });

        List.value = response["result"];
        console.log(List.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }
    const dataEdit = ref();
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function IsEdit(data) {
      debugger;
      editItems.value = data;
      Editmodel.value = false;
      showDialog.value = true;
    }
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    //Delete-Popup
    async function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    //Delete Values in Table
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      try {
        let result: any = "";
        if (data.ActiveStatus == 0) {
          result = await StockReasonService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          result = await StockReasonService.active(data.Id, status);
        }
        // const result = await StockReasonService.deletedata(data.Id, data.ActiveStatus);
        let message = result["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        console.log(error);
      }
    }
    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }
    //Deleted Sucessfully Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
    }
    return {
      EntityData,
      headers,
      List,
      showmodalref,
      showpopModal: showmodalref,
      stockreason,
      IsDelete,
      IsShow,
      loading1,
      filters,
      globalFilterFields,
      IsConfirmDel,
      Deletemodel,
      deletepop,
      closetrigger,
      showDialog,
      editItems,
      Editmodel,
      IsConfirmEdit,
      RowClick,
      dataEdit,
      IsEdit,
      IsAdd,
      loading,
      toggle,
      itemListed,
      menu,
      contentdel,
      pop,
      ObjOperationId,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>
<style lang="scss" scoped>
.mobileroomname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
  margin-bottom: -5px;
}

.mobileremarksname {
  font-size: 14px;
  color: #999999;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
